import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as PlusIcon } from 'assets/bosta-icons/Plus.svg';

const NewPageBtn = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  return (
    <BRButton
      type="primary"
      label={formatMessage({
        id: 'pages.empty_state.new_pages_btn'
      })}
      prefixIcon={<PlusIcon />}
      onClick={() => history.push('/pages/create')}
    />
  );
};

export default NewPageBtn;
